import { render, staticRenderFns } from "./aIndex.vue?vue&type=template&id=18754bd3&scoped=true&"
import script from "./aIndex.vue?vue&type=script&lang=js&"
export * from "./aIndex.vue?vue&type=script&lang=js&"
import style0 from "./aIndex.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18754bd3",
  null
  
)

export default component.exports